// extracted by mini-css-extract-plugin
export default {"loader":"loader","dot1":"dot1","dot2":"dot2","dot3":"dot3","dot-loader":"dot-loader"};